// extracted by mini-css-extract-plugin
export default {"wrapper":"errormessage_wrapper__JfyOg","title":"errormessage_title__TN7ir","img":"errormessage_img__m5obO","message":"errormessage_message__n82NM"};